module.exports = __webpack_public_path__ + "static/media/communication.9bca4df5.jpg";